import { Options } from 'vue-class-component';
import {
  ComponentType,
  DeviceDTO,
  DevicesFilterByType,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import AddDeviceToLinkableObject from '@/views/components/AddDeviceToLinkableObject/AddDeviceToLinkableObject.vue';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import ThermoGeneralStep from '../ThermoGeneralStep';

@Options({
  name: 'Step1AssignThermostat',
  components: {
    AddDeviceToLinkableObject,
  },
  watch: {
    atLeastOneDeviceSelected: function () {
      this.validateNextEnabled();
    },
  },
})
export default class Step1AssignThermostat extends ThermoGeneralStep {
  devicesThermostatsTmp: DeviceDTO[] = [];

  get currentDevicesThermostats() {
    return this.roomObject.devices?.filter(
      (x) =>
        x.isThermostatDevice &&
        x.slots?.some((x) => x.assignedComponentType == ComponentType.Thermo)
    );
  }

  get devicesThermostats() {
    return this.devicesThermostatsTmp.filter(
      (x) => !this.roomObject.devices?.some((k) => k.id === x.id)
    );
  }

  created() {
    this.validateNextEnabled();
  }

  async mounted() {
    this.$store.dispatch(SET_APP_LOADING, true);

    try {
      this.devicesThermostatsTmp = await plantsClient.devices(
        this.plantId,
        this.roomId,
        this.roomObject.id ?? '',
        DevicesFilterByType.THERMO,
        undefined,
        this.roomObject.heatingSystemControlType || undefined,
        this.roomObject.coolingSystemControlType || undefined,
        this.roomObject.sharedSystemControlType || undefined
      );
    } catch (error) {
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  get atLeastOneDeviceSelected() {
    return (this.currentDevicesThermostats?.length ?? 0) > 0;
  }

  validateNextEnabled() {
    this.nextEnabled = this.atLeastOneDeviceSelected;
  }
}
